// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DKag","content":"styles_content__R3Ce1","row":"styles_row__1YnHX","footer":"styles_footer__hk2t-","phraseLength":"styles_phraseLength__2iWz3"};